module.exports = __webpack_public_path__ + "img/right-arrow.06b1976f.svg";